import ReactQuill from 'react-quill';
import classnames from 'classnames';
import Icon from '@ant-design/icons';
import { injectIntl } from 'react-intl';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as ReturnOrders } from 'assets/bosta-icons/Return.svg';
import { ReactComponent as StarsIcon } from 'assets/bosta-icons/stars.svg';

import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import './BRRichTextEditor.less';

const BRRichTextEditor = ({
  intl,
  theme = 'snow',
  className = '',
  value = '',
  onChange = () => {},
  placeholder = '',
  readOnly = false,
  isEmpty = false,
  emptyStateAction = () => {},
  handleChangeSelection = () => {},
  reactQuillRef = null
}) => {
  return (
    <div className="br-rich-text-editor__container">
      {isEmpty && (
        <div className="br-rich-text-editor__empty-state">
          <Icon className="ant-icon-xl" component={ReturnOrders} />
          <div>
            <span className="heading">
              {intl.formatMessage({
                id: 'products.sllr_store.return_process_title'
              })}
            </span>
            <span className="body">
              {intl.formatMessage({
                id: 'products.sllr_store.return_process_subtitle'
              })}
            </span>
          </div>
          <BRButton
            type="primary"
            className="button"
            label={intl.formatMessage({
              id: 'products.sllr_store.create_template'
            })}
            prefixIcon={<Icon className="ant-icon-md" component={StarsIcon} />}
            onClick={emptyStateAction}
          />
        </div>
      )}
      <ReactQuill
        theme={theme}
        value={value}
        onChange={onChange}
        className={classnames('br-rich-text-editor', {
          'br-rich-text-editor__blurry': isEmpty,
          [className]: className
        })}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
        readOnly={readOnly}
        onChangeSelection={handleChangeSelection}
        ref={reactQuillRef}
      />
    </div>
  );
};

const modules = {
  toolbar: [
    [{ header: [] }],
    ['bold', 'italic', 'underline', 'strike', 'link'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }, { direction: 'rtl' }],
    [{ color: [] }]
  ]
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'link',
  'align',
  'direction',
  'color'
];

export default injectIntl(BRRichTextEditor);
